import Seo from "@/components/Seo"
import { LowerRegions } from "@/configs/region"
import React from "react"
import { BeyondShopSection } from "./BeyondShopSection"
import { CheckoutSection } from "./CheckoutSection"
import { DisclaimerSection } from "./DisclaimerSection"
import { DownloadAppSection } from "./DownloadAppSection"
import { GiftCardSection } from "./GiftCardSection"
import HeroSection from "./HeroSection"
import { MerchantSection } from "./MerchantSection"
import { OneTimeCardSection } from "./OneTimeCardSection"
import { getRegionConfig } from "./getRegionConfig"
import { usePageRegion } from "../NavBar/usePageRegion"
import { OneLinkProvider } from "@/utils/onelink/SmartScriptProvider"

const PayPage = () => {
  const { pageRegion } = usePageRegion()
  const region = pageRegion ? pageRegion.toLowerCase() : "global"
  const config = getRegionConfig(region as LowerRegions)

  const {
    isShowOneTimeCardSection,
    heroSectionBackground,
    SendReceiveImage,
    newMerchantSection,
    SendPayMentUI,
    beyondShopSection,
    disclaimerSection,
  } = config

  return (
    <>
      <OneLinkProvider
        pageName="Pay"
        oneLinkKey="Pay Page CTA"
        deepLinkValue="monaco://crm/pay"
        afWebDp={"https://web.crypto.com/hub/market"}
        defaultURL={"https://crypto.onelink.me/J9Lg/smartscriptfallback"}
      >
        <Seo page="pay" />
        <HeroSection bg={heroSectionBackground} />
        <MerchantSection
          title={newMerchantSection.title}
          maxWidth={newMerchantSection.titleMaxWidth}
        />
        <CheckoutSection SendPayMentUI={SendPayMentUI} />
        <GiftCardSection />
        {isShowOneTimeCardSection && <OneTimeCardSection />}
        <BeyondShopSection
          SendReceiveImage={SendReceiveImage}
          description={beyondShopSection.description}
        />
        <DownloadAppSection />
        <DisclaimerSection disclaimer={disclaimerSection.disclaimer} />
      </OneLinkProvider>
    </>
  )
}

export default PayPage
